import { Video, Image as ImageIcon } from 'lucide-react'

const MediaDisplay = ({ 
  src, 
  alt = '', 
  className = '', 
  isVideo = null,
  showControls = true,
  onError = null 
}) => {
  // Détection améliorée du type de média
  const detectMediaType = (url) => {
    if (!url) return 'image'
    
    // Si isVideo est explicitement défini, l'utiliser
    if (isVideo !== null) return isVideo
    
    // Détecter les extensions vidéo réelles
    const videoExtensions = ['.mp4', '.webm', '.ogv', '.mov', '.avi']
    const isVideoUrl = videoExtensions.some(ext => url.toLowerCase().includes(ext))
    
    // Détecter les URLs blob vidéo (généralement avec type)
    const isVideoBlob = url.startsWith('blob:') && (
      url.includes('/video/') || 
      url.includes('type=video') ||
      url.includes('mp4')
    )
    
    return isVideoUrl || isVideoBlob
  }

  const isVideoFile = detectMediaType(src)

  const handleError = (e) => {
    if (onError) {
      onError(e)
    } else {
      // Comportement par défaut pour les images
      if (!isVideoFile) {
        e.target.src = 'https://via.placeholder.com/400x200?text=Image+non+disponible'
      }
    }
  }

  return (
    <div className={`relative ${className}`}>
      {isVideoFile ? (
        <video
          src={src}
          className="w-full h-full object-cover"
          controls={showControls}
          onError={handleError}
        />
      ) : (
        <img
          src={src}
          alt={alt}
          className="w-full h-full object-cover"
          onError={handleError}
        />
      )}
      
      {/* Indicateur de type de média */}
      {isVideoFile && (
        <div className="absolute top-2 right-2 bg-black/70 text-white px-2 py-1 rounded text-xs flex items-center space-x-1">
          <Video className="w-3 h-3" />
          <span>MP4</span>
        </div>
      )}
    </div>
  )
}

export default MediaDisplay
